import { render, staticRenderFns } from "./empresa-detalhe-dados.vue?vue&type=template&id=2f2d0b59&"
import script from "./empresa-detalhe-dados.vue?vue&type=script&lang=js&"
export * from "./empresa-detalhe-dados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports